import { MenuItem } from './menu.model';
import { ApiserviceService } from 'src/app/core/services/apiservice.service';

export const MENU:MenuItem[] =[
 
    {
        id: 1,
        label: 'ANA MENU',
        isTitle: true
    },
  
    {
        id: 2,
        label: 'Anasayfa',
        link: '',
        icon:'bx-home'
    },
     {
        id: 3,
        label: 'Arşiv',
        link: '/arsiv',
        icon:'bx-box'
    },
    {
        id: 4,
        label: 'Kullanıcılar',
        link: '/users',
        icon:'bx-user'
    },


];
